import NotificationsOutlined from '@mui/icons-material/NotificationsOutlined';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { useRef, useState } from 'react';
import { NotificationsFeed } from './NotificationsFeed';

const POPOVER_MAX_HEIGHT = '80vh';
const POPOVER_MAX_WIDTH = '560px';

export const NotificationsButton = () => {
  const popperRef = useRef<HTMLDivElement>(null);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handlePopper = (event?: React.MouseEvent<HTMLElement>) => {
    if (anchorEl || !event) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <>
      <IconButton
        onClick={handlePopper}
        sx={{
          backgroundColor: anchorEl ? '#D5DFE4' : 'transparent',
          color: '#00293A',
        }}
      >
        <NotificationsOutlined />
      </IconButton>
      <Popover
        disableScrollLock={true}
        data-testid="share-document-menu"
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 0.5,
              maxHeight: POPOVER_MAX_HEIGHT,
              overflow: 'auto',
              minWidth: '520px',
              maxWidth: POPOVER_MAX_WIDTH,
              width: 'auto',
            },
          },
        }}
        onClose={() => {
          setAnchorEl(null);
        }}
      >
        <div ref={popperRef}>
          <NotificationsFeed onClose={() => setAnchorEl(null)} />
        </div>
      </Popover>
    </>
  );
};
